export default () => ({
	data: [],

	gtm(data) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(data);
	},
});
